export default {
	matching: 'Mutabakat'
}